import React from "react";
import SimpleBanner from "../../components/common/Banner";
import ProjectsList from "../../components/ProjectPageComponents/ProjectsList";

const ProjectListing = () => {
  return (
    <div className="overflow-hidden">
      <SimpleBanner name_primary="Our" name_secondary="Projects" />
      <div>
        <ProjectsList />
      </div>
    </div>
  );
};

export default ProjectListing;
